import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from 'date-fns/locale';

/**
 * TimeField — input de hora 24h centralizado, força formato HH:mm sem AM/PM.
 *
 * Props:
 *   label        string
 *   value        string  — formato "HH:mm" (ex: "09:00")
 *   onChange     (hhmm: string) => void — sempre devolve "HH:mm"
 *   [qualquer prop extra do TextField do MUI]
 *
 * Força 24h em qualquer locale do navegador.
 */
export default function TimeField({ label, value, onChange, ...rest }) {
  // Converte string "HH:mm" para Date
  const parseTime = (hhmm) => {
    if (!hhmm) return null;
    const [h, m] = hhmm.split(':').map(Number);
    const d = new Date();
    d.setHours(h, m, 0, 0);
    return d;
  };

  // Converte Date para string "HH:mm"
  const formatTimeHHmm = (date) => {
    if (!date) return '';
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  };

  const handleChange = (newValue) => {
    const formatted = formatTimeHHmm(newValue);
    onChange(formatted);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <TimePicker
        label={label}
        value={parseTime(value)}
        onChange={handleChange}
        ampm={false}
        format="HH:mm"
        slotProps={{
          textField: {
            size: 'small',
            ...rest,
          },
        }}
      />
    </LocalizationProvider>
  );
}
